import React from 'react';
import Breadcrumb from '../../../components/Breadcrumb';
import BlogSeries from '../../../components/BlogSeries';

const posts = [
  {
    num: 'iam',
    title: 'Step 1 - Identity and Access Management (IAM)',
    date: 'May 9, 2025',
    summary:
      'How lean SaaS and AI startups can implement practical, affordable Identity and Access Management (IAM) on AWS to meet SOC 2 compliance. Covers SSO, RBAC, least privilege, and real-world tips for audit success.',
    hashtags: ['#SOC2', '#IAM', '#AWS', '#StartupSecurity', '#Compliance'],
  },
];

const SOC2LeanStartups = () => (
  <div className="soc2-lean-startups-page blog-page">
    <Breadcrumb
      items={[
        { path: '/', label: 'Home' },
        { path: '/blog', label: 'Blog' },
        { path: '/blog/soc2-for-lean-startups', label: 'SOC 2 for Lean Startups' },
      ]}
    />
    <BlogSeries
      posts={posts}
      seriesTitle="SOC 2 for Lean Startups"
      seriesPath="/blog/soc2-for-lean-startups"
    />
  </div>
);

export default SOC2LeanStartups;
